import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { isArrivalOrderScheduleType } from './_consts/schedule-format';

import type { RescheduleAvailableHour } from '@/app/(main)/(pages)/(auth)/agendamentos/_components/card-appointment/variants/_components/appointment-options/_services/get-appointment-avaiable-hours.service';
import { Spinner } from '@/components/ui/spinner.component';
import { dateFormatter } from '@/utils/formatters/date';

interface RescheduleSlotButtonProps {
  slot: RescheduleAvailableHour;
  isLoading: boolean;
  isDisabled: boolean;
  onClick: () => void;
}

const formatSlotLabel = (slot: RescheduleAvailableHour): string =>
  isArrivalOrderScheduleType(slot.scheduleType)
    ? `${dateFormatter(slot.start, 'HH:mm')} às ${dateFormatter(slot.end, 'HH:mm')}`
    : dateFormatter(slot.start, 'HH:mm');

export function RescheduleSlotButton({ slot, isLoading, isDisabled, onClick }: RescheduleSlotButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={isDisabled || isLoading}
      data-testid={`${DataTestIdEnum.APPOINTMENT_RESCHEDULE_SLOT}-${slot.id}`}
      className="flex w-full items-center justify-center rounded-lg bg-green-100 px-4 py-2 text-base font-semibold text-green-500 transition-opacity hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-50"
    >
      {isLoading ? <Spinner /> : formatSlotLabel(slot)}
    </button>
  );
}
